<template>
	<div>
		<div style="text-align: left; padding-bottom: 10px;">
			
			
		</div>
		<el-table :data="tableData" style="width: 100%" border stripe>
			<el-table-column prop="id" label="编号" width="50"></el-table-column>
      		<el-table-column prop="goodsName" label="产品名称" width="180"></el-table-column>
      		<el-table-column prop="telephone" label="电话" width="180"></el-table-column>
      		<el-table-column prop="toName" label="收获人" width="160"></el-table-column>
      		<el-table-column prop="address" label="收获地址" width="160"></el-table-column>
      		<el-table-column prop="createTime" label="下单时间" width="160"></el-table-column>
      		<el-table-column prop="state" label="状态" width="180">
	  			<template slot-scope="scope">
					<el-tag v-if="scope.row.state==0" type="danger">无效</el-tag>
					<el-tag v-if="scope.row.state==1" type="success">有效</el-tag>
				</template>
      		</el-table-column>	
      		<el-table-column label="操作" width="250">
      			<template scope="scope">
					<el-button size="small" v-if="scope.row.state==0" @click="visibleGoodsOrder(scope.$index, scope.row)">置为有效</el-button>
					<el-button size="small" v-if="scope.row.state==1" @click="visibleGoodsOrder(scope.$index, scope.row)">置为无效</el-button>
					<el-button size="small" @click="goodsOrderUpdate(scope.$index, scope.row)">修改</el-button>
				</template>
      		</el-table-column>
      	</el-table>
      	<el-pagination background ayout="prev, next" @current-change="handlerCurrentPage"  :page-size="pageSize" :total="total">
		</el-pagination>


		
	</div>

	
</template>
<script >
	import {getGoodsOrderList,visibleGoodsOrder} from "@/api/api"
	export default {
		data(){
		 	return {
		 		tableData:[],
		 		pageSize:15,
		 		total:0,
		 		pageCount:0,
		 		companyName:''
		 	}
		},
		created:function() {
			var _this = this;
			let params = {pageNum:0,pageSize:this.pageSize};
			getGoodsOrderList(params).then(res =>{
				this.tableData = res.data.data.list;
				this.total = res.data.data.total;
				this.pageCount=res.data.data.pages;
			});
			
		},
		methods:{
			searchLine(){
				this.reload();
			},
			handlerCurrentPage(currentPage){
				let params = {pageNum:currentPage,pageSize:this.pageSize};
				getGoodsOrderList(params).then(res =>{
					this.tableData = res.data.data.list;
					this.total = res.data.data.total;
					this.pageCount = res.data.data.pages;
				});
			},
			goodsOrderUpdate(index,row){
				var param={};
				if(row){
					param.id = row.id;
				}
				this.$router.push({name:"goodsOrderUpdate",query:param});
			},
			reload(){
				console.log("reload");
				let params = {pageNum:this.currentPage,pageSize:this.pageSize,companyName:this.companyName};
				getGoodsOrderList(params).then(res =>{
					this.tableData = res.data.data.list;
					this.total = res.data.data.total;
					this.pageCount = res.data.data.pages;
					this.currentPage = res.data.data.pageNum;
				});
			},
			visibleGoodsOrder(index,row){
				let _this = this;
				let params={id:row.id};
				if(row.state==1){
					params.state=0;
				}else{
					params.state=1;
				}
				visibleGoodsOrder(params).then(res=>{
					if(res.data.status=='success'){
						this.$message({
					            type: 'success',
					            message: '操作成功'
					         });
						_this.reload();
					}
				});
			}
		}
	}
</script>